import React from "react";
import "./Footer.css";

function Footer () {
  return(
    <footer>
      <h1>Matching Game</h1>
      <a href="https://github.com/zachyingling/react-clickygame">Repo</a>
    </footer>
  );
}

export default Footer;